import React from 'react';
import Button from './Button';


const ChartToggle = ({ chartType, onChartTypeChange, className = '' }) => {
  const chartTypes = [
    {
      type: 'bar',
      label: 'Bar Chart',
      icon: 'BarChart3',
      description: 'Vertical bar visualization'
    },
    {
      type: 'line',
      label: 'Line Chart', 
      icon: 'TrendingUp',
      description: 'Line graph visualization'
    },
    {
      type: 'area',
      label: 'Area Chart',
      icon: 'Activity',
      description: 'Filled area visualization'
    }
  ];

  return (
    <div className={`flex items-center space-x-2 ${className}`}>
      <span className="text-sm font-medium text-muted-foreground mr-2">Chart Type:</span>
      <div className="flex items-center bg-muted rounded-lg p-1">
        {chartTypes?.map((chart) => (
          <Button
            key={chart?.type}
            variant={chartType === chart?.type ? 'default' : 'ghost'}
            size="sm"
            onClick={() => onChartTypeChange(chart?.type)}
            iconName={chart?.icon}
            iconSize={16}
            className={`h-8 px-3 text-xs ${
              chartType === chart?.type 
                ? 'bg-primary text-primary-foreground shadow-sm' 
                : 'text-muted-foreground hover:text-foreground hover:bg-background'
            }`}
            title={chart?.description}
          >
            {chart?.label}
          </Button>
        ))}
      </div>
    </div>
  );
};

export default ChartToggle;